import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import PageHeader from '../components/ui/PageHeader';

const eventConfig = {
  created: { label: 'Creado',    bg: '#D1FAE5', color: '#065F46' },
  updated: { label: 'Editado',   bg: '#DBEAFE', color: '#1D4ED8' },
  deleted: { label: 'Eliminado', bg: '#FEE2E2', color: '#991B1B' },
};

const moduleLabels = {
  'case-files':   'Expedientes',
  'clients':      'Clientes',
  'budgets':      'Presupuestos',
  'appointments': 'Citas',
};

const inputSt = { width: '100%', padding: '7px 10px', border: '1.5px solid #E5E7EB', borderRadius: 8, fontSize: 13, color: '#111827', backgroundColor: '#fff', outline: 'none', fontFamily: 'inherit' };
const focusSt = e => { e.target.style.borderColor = '#4F63D2'; e.target.style.boxShadow = '0 0 0 3px rgba(79,99,210,0.1)'; };
const blurSt  = e => { e.target.style.borderColor = '#E5E7EB'; e.target.style.boxShadow = 'none'; };

const Label = ({ children }) => (
  <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#374151', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
    {children}
  </label>
);

const AuditLog = () => {
  const [logs, setLogs]       = useState([]);
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ type: '', causer_id: '', date_from: '', date_to: '' });

  const fetchUsers = async () => {
    try { const res = await api.get('/users'); setUsers(res.data); }
    catch (e) { console.error(e); }
  };

  const fetchLogs = async (overrideFilters) => {
    setLoading(true);
    try {
      const f = overrideFilters ?? filters;
      const params = {};
      if (f.type)       params.subject_type = f.type;
      if (f.causer_id)  params.causer_id    = f.causer_id;
      if (f.date_from)  params.date_from    = f.date_from;
      if (f.date_to)    params.date_to      = f.date_to;
      const res = await api.get('/activity-log', { params });
      setLogs(res.data.data ?? res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchUsers(); fetchLogs(); }, []); // eslint-disable-line

  const handleFilter = e => { e.preventDefault(); fetchLogs(); };

  const handleReset = () => {
    const empty = { type: '', causer_id: '', date_from: '', date_to: '' };
    setFilters(empty);
    fetchLogs(empty);
  };

  return (
    <div>
      <PageHeader
        title="Log de Auditoría"
        subtitle="Historial de cambios realizados en el sistema"
        actions={
          <span style={{ fontSize: 12, fontWeight: 600, padding: '4px 12px', borderRadius: 20, backgroundColor: '#EEF0FB', color: '#4F63D2' }}>
            {logs.length} registros
          </span>
        }
      />

      {/* Filtros */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E5E7EB', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', marginBottom: 20, overflow: 'hidden' }}>
        <div style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg width="14" height="14" fill="none" stroke="#9CA3AF" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
          </svg>
          <span style={{ fontWeight: 700, fontSize: 13, color: '#374151' }}>Filtros</span>
        </div>
        <div style={{ padding: 20 }}>
          <form onSubmit={handleFilter}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '0 16px', alignItems: 'end' }}>
              <div style={{ marginBottom: 14 }}>
                <Label>Módulo</Label>
                <select value={filters.type} onChange={e => setFilters({ ...filters, type: e.target.value })}
                  style={{ ...inputSt, cursor: 'pointer' }} onFocus={focusSt} onBlur={blurSt}>
                  <option value="">Todos</option>
                  {Object.entries(moduleLabels).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
                </select>
              </div>
              <div style={{ marginBottom: 14 }}>
                <Label>Usuario</Label>
                <select value={filters.causer_id} onChange={e => setFilters({ ...filters, causer_id: e.target.value })}
                  style={{ ...inputSt, cursor: 'pointer' }} onFocus={focusSt} onBlur={blurSt}>
                  <option value="">Todos</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 14 }}>
                <Label>Desde</Label>
                <input type="date" value={filters.date_from} onChange={e => setFilters({ ...filters, date_from: e.target.value })}
                  style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </div>
              <div style={{ marginBottom: 14 }}>
                <Label>Hasta</Label>
                <input type="date" value={filters.date_to} onChange={e => setFilters({ ...filters, date_to: e.target.value })}
                  style={inputSt} onFocus={focusSt} onBlur={blurSt} />
              </div>
              <div style={{ marginBottom: 14, display: 'flex', gap: 8 }}>
                <button type="submit"
                  style={{ flex: 1, padding: '7px 14px', borderRadius: 8, border: 'none', backgroundColor: '#4F63D2', color: '#fff', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3d4fb8'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = '#4F63D2'}>
                  Filtrar
                </button>
                <button type="button" onClick={handleReset}
                  style={{ padding: '7px 14px', borderRadius: 8, border: '1.5px solid #E5E7EB', backgroundColor: '#fff', fontWeight: 600, fontSize: 13, cursor: 'pointer', color: '#374151' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#D1D5DB'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#E5E7EB'}>
                  Limpiar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Tabla */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E5E7EB', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 48 }}>
            <div style={{ width: 28, height: 28, border: '3px solid #EEF0FB', borderTopColor: '#4F63D2', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
          </div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#9CA3AF', fontSize: 14 }}>
            No hay registros de auditoría
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
              <thead>
                <tr style={{ backgroundColor: '#F9FAFB' }}>
                  {[
                    { label: 'Acción',   w: '10%' },
                    { label: 'Módulo',   w: '12%' },
                    { label: 'ID',       w: '7%' },
                    { label: 'Usuario',  w: '14%' },
                    { label: 'Cambios',  w: '42%' },
                    { label: 'Fecha',    w: '15%' },
                  ].map(({ label, w }) => (
                    <th key={label} style={{ width: w, padding: '10px 14px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9CA3AF', textAlign: 'left', borderBottom: '1px solid #F3F4F6' }}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {logs.map(log => {
                  const ev = eventConfig[log.event] || { label: log.event, bg: '#F3F4F6', color: '#374151' };
                  return (
                    <tr key={log.id}
                      style={{ borderBottom: '1px solid #F9FAFB' }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#FAFBFF'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}>
                      <td style={{ padding: '11px 14px' }}>
                        <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20, backgroundColor: ev.bg, color: ev.color }}>
                          {ev.label}
                        </span>
                      </td>
                      <td style={{ padding: '11px 14px', fontSize: 12, color: '#374151', fontWeight: 500 }}>
                        {moduleLabels[log.subject_type] || log.subject_type}
                      </td>
                      <td style={{ padding: '11px 14px', fontSize: 12, color: '#9CA3AF' }}>
                        #{log.subject_id}
                      </td>
                      <td style={{ padding: '11px 14px', fontSize: 12, color: '#4B5563', fontWeight: 500 }}>
                        {log.causer}
                      </td>
                      <td style={{ padding: '11px 14px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                        {log.old && log.new ? (
                          <div style={{ fontSize: 11 }}>
                            {Object.keys(log.new).map(key =>
                              log.old[key] !== log.new[key] ? (
                                <div key={key} style={{ marginBottom: 3 }}>
                                  <span style={{ color: '#9CA3AF' }}>{key}:</span>{' '}
                                  <span style={{ color: '#EF4444', textDecoration: 'line-through' }}>{String(log.old[key] ?? '—')}</span>
                                  {' → '}
                                  <span style={{ color: '#059669' }}>{String(log.new[key] ?? '—')}</span>
                                </div>
                              ) : null
                            )}
                          </div>
                        ) : (
                          <span style={{ fontSize: 12, color: '#9CA3AF' }}>{log.description}</span>
                        )}
                      </td>
                      <td style={{ padding: '11px 14px', fontSize: 12, color: '#9CA3AF' }}>
                        {new Date(log.created_at).toLocaleDateString('es-MX', {
                          day: '2-digit', month: 'short', year: 'numeric',
                          hour: '2-digit', minute: '2-digit'
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditLog;
